import React from 'react';

import './Aside.css';

const Aside = () => {
    return (
        <aside>
            <img src='headshot.JPG' alt='kevin headshot' />
        </aside>
    );
};

export default Aside;



// WEBPACK FOOTER //
// ./src/components/Aside.js